// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionAdministration_container__6g2vO","button-container":"SubscriptionAdministration_button-container__gYvJp"};